import { render, staticRenderFns } from "./AbandonedSupplierPage.vue?vue&type=template&id=7ab20188&scoped=true&"
import script from "./AbandonedSupplierPage.vue?vue&type=script&lang=js&"
export * from "./AbandonedSupplierPage.vue?vue&type=script&lang=js&"
import style0 from "./AbandonedSupplierPage.vue?vue&type=style&index=0&id=7ab20188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab20188",
  null
  
)

export default component.exports